export enum ButtonType {
  PRIMARY = 'button-primary',
  SECONDARY = 'button-secondary',
  LINK = 'button-tercial',
  MENU = 'button-menu',
  OUTLINE = 'button-outline',
  OUTLINE_INVERSE = 'button-outline-inverse',
  DESTRUCTIVE = 'button-destructive',
  CLEAR = 'button-clear',
  UNSTYLED = 'button-unstyled',
}
